<template>
  <v-container fluid class="custom-container">
    <div class="context-menu" style="display:none">
      <div @click="deleteFolder">Remover</div>
    </div>

    <!-- Folders Header -->
    <v-layout
      v-if="!isEmpty(groupedFolders)"
      class="mb-2 list-folders-actions align-center"
      row
      wrap
    >
      <v-flex xs12 sm6 md3>
        <div class="d-flex align-center">
          <strong v-if="!isEmpty(activeFolderFilterType)" class="mr-2">Filtrado por:</strong>
          <v-chip
            v-if="!isEmpty(activeFolderFilterType)"
            close
            @input="resetFolders"
            color="white"
          >{{ activeFolderFilterType.name }}
          </v-chip>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <div class="d-flex align-center">
          <span class="mr-2">Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
          <v-btn icon small @click="pageNumber--" :disabled="pageNumber <= 1">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon small @click="pageNumber++" :disabled="pageNumber >= pages">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-select
          v-model="orderFilter"
          :items="orderFilters"
          item-text="name"
          return-object
          hide-details
          solo
          flat
          dense
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="justify-center" style="display: flex">
        <v-btn-toggle v-model="viewMode" mandatory dense>
          <v-btn flat small :value="'list'">
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
          <!-- <v-btn flat small :value="'grid'">
            <v-icon>mdi-grid</v-icon>
          </v-btn>-->
        </v-btn-toggle>
      </v-flex>
    </v-layout>

    <!-- Vista em Lista -->
    <template v-if="viewMode === 'list'">
      <section class="folders">
        <v-layout
          class="folder-list mt-4"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text my-2 text-capitalize"
          > {{ index }}</span>

          <div class="elevation-1 group" v-if="group.length > 0">
            <draggable :options="{ delay: dragDelay }">
              <transition-group
                name="fade-cascade"
                tag="div"
                class="cascade-group"
                appear
              >
                <folder-card
                  v-for="(folder, folderIndex) in group"
                  :key="folder.id"
                  :folder="folder"
                  :draggingItemId="draggingItemId"
                  :style="{ '--cascade-delay': `${folderIndex * 0.05}s` }"
                  @update:draggingItemId="id => draggingItemId = id"
                  @drag-start="startDrag"
                  @open-folder="openFolder"
                />
              </transition-group>
            </draggable>
          </div>
        </v-layout>
      </section>
    </template>

    <!-- Vista em Grid -->
    <template v-else>
      <section class="folders">
        <v-layout
          class="folder-list mt-4"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text my-2 text-capitalize"
          > {{ index }}</span>

          <folder-grid
            :folders="group"
            v-if="group.length > 0"
          />
        </v-layout>
      </section>
    </template>

    <!-- Empty Content -->
    <v-container fill-height v-if="isEmpty(groupedFolders) && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-inbox</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>
  </v-container>
</template>


<script>
import { isEmpty, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import bus from "@/utils/event-bus";
import CurrentOwner from "@/components/inbox/CurrentOwner";
import TermComponent from "@/components/inbox/TermComponent";
import foldersService from "../../../../services/FoldersService";
import customFolderService from "../../../../services/CustomFolderService";
import draggable from "vuedraggable";
import FolderCard from '@/components/folder/FolderCard';
import FolderGrid from '@/components/folder/FolderGrid';

export default {
  name: "inbox",
  components: {
    CurrentOwner,
    TermComponent,
    draggable,
    FolderCard,
    FolderGrid
  },
  mounted() {
    this.setInboxFoldersTypes();
    bus.$on("folderCreated", () => {
      this.getFolders();
    });
    bus.$on("loadInboxFolder", () => {
      this.getFolders();
    });
  },
  data() {
    return {
      firstRender: true,
      orderFilters: [
        // { name: "Menor prazo", property: "limit_date", order: "asc" },
        // { name: "Maior prazo", property: "limit_date", order: "desc" },
        {
          name: "Tramitação mais antiga",
          property: "effective_updated_at",
          order: "asc"
        },
        {
          name: "Tramitação mais recente",
          property: "effective_updated_at",
          order: "desc"
        }
      ],
      orderFilter: {
        name: "Tramitação mais recente",
        property: "effective_updated_at",
        order: "desc"
      },
      truncateText: truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      selectedFolderId: null,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500,
      viewMode: 'list',  // 'list' ou 'grid'
      isLoadingFolders: false  // Flag para controlar requisições simultâneas
    };
  },
  created() {
    document.addEventListener("click", this.closeContextMenu);
  },
  destroyed() {
    document.removeEventListener("click", this.closeContextMenu);
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    showMenu(event, folderId) {
      this.selectedFolderId = folderId;

      const contextMenu = document.querySelector(".context-menu");

      contextMenu.style.display = "block";
      const offsetX = 350;
      const offsetY = 60;
      contextMenu.style.left = event.clientX - offsetX + "px";
      contextMenu.style.top = event.clientY - offsetY + "px";
    },
    closeContextMenu(event) {
      const contextMenu = document.querySelector(".context-menu");
      if (contextMenu) {
        contextMenu.style.display = "none";
      }
    },
    deleteFolder() {
      customFolderService
        .deleteFolderFromCustomFolder(
          this.$route.params.id,
          this.selectedFolderId
        )
        .then(() => {
          this.$store.dispatch("toggleSnackbar", {
            show: true,
            color: "success",
            message: "Processo removido com sucesso!",
            messageIcon: "mdi-check-circle-outline"
          });

          this.$store.commit("setFolderIdCounter", this.$route.params.id);
          this.$store.commit("incrementCallCounter");
        })
        .catch(() => {
          this.$store.dispatch("toggleSnackbar", {
            show: true,
            color: "error",
            message: "Erro ao tentar remover processo da pasta!",
            messageIcon: "mdi-alert-circle-outline"
          });
        })
        .finally(() => {
          this.getFolders();
          this.closeContextMenu(event);
        });
    },
    folderNotReceivedClass(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "received-folder";
      }
      return "";
    },
    folderIcon(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "/static/images/folder/folder-open-icon.svg";
      }
      return "/static/images/folder/folder-closed-icon.svg";
    },

    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders(loading = true) {
      if (loading) {
        this.$store.dispatch("toggleLoader", { show: true });
      }

      this.$store
        .dispatch("getCustomFolders", {
          id: this.$route.params.id,
          page: this.pageNumber,
          limit: this.rowsPerPage,
          order: this.orderFilter.order,
          sort: this.orderFilter.property,
          searchText: this.searchText || "",
          folderTypeId: this.folderTypeSelected.id || ""
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
          this.$store.dispatch("setLoadingSearchText", false);
        });
      this.$store.dispatch("getFoldersCount");
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    resetFolders() {
      this.pageNumber = 1;
      this.$store.dispatch("setFolderTypeSelected", "");
      // this.$store.dispatch('getFoldersInbox');
      this.$store.dispatch("setActiveFolderFilterType", {});
    },
    setInboxFoldersTypes() {
      // foldersService.getFolderTypesOnInbox().then(response => {
      //   this.$store.dispatch("setFolderTypes", response.data);
      // });
    },
    orderDateToString(folder) {
      switch (this.orderFilter.property) {
        case "limit_date":
          return folder.limit_date == null
            ? "Sem limite"
            : this.formatMonthYear(folder.limit_date);
        case "created_at":
          if (folder.last_transaction == null) {
            return "Processos não tramitados";
          }
          return this.formatMonthYear(folder.last_transaction.created_at);
        default:
          return "Sem agrupamento";
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    activeFolderFilterType() {
      return this.$store.getters.activeFolderFilterType;
    },
    folders() {
      return this.$store.getters.folders;
    },
    received() {
      if (this.$store.getters.folders.length === undefined) {
        return [];
      }

      const received = this.$store.getters.folders.filter(
        item => item.folder_section === "inbox"
      );
      // if (!isEmpty(this.activeFolderFilterType)) {
      //   received = this.$store.getters.folders.filter(
      //     item => item.folder_section === 'inbox',
      //   );
      //   received = received.filter(
      //     item => item.folder_type.id === this.activeFolderFilterType.id,
      //   );
      //   this.$store.dispatch('setFoldersFound', received);
      // }
      return received;
    },
    groupedFolders() {
      const group = {};
      this.received.forEach(folder => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    },
    folderTypeSelected() {
      return this.$store.getters.folderTypeSelected;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders(false);
      }
    },
    folderTypeSelected() {
      this.getFolders();
    },
    orderFilter: {
      handler: "getFolders"
    },
    "$route.params.id": {
      handler() {
        this.getFolders();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.received-folder {
  background: #f2f2f2;
  font-weight: 600 !important;

  &.caption {
    font-weight: 600 !important;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 70px;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 600px) {
    position: relative;
    width: 100%;
    margin-top: 0;
    padding: 4px;
  }
}

.folder-list {
  .group {
    position: relative;
    overflow: hidden;
  }
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}

.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 8px 0;
  min-width: 120px;

  div {
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/custom/CustomFolder.vue